import React, { useEffect } from "react";
import { Form, Input, DatePicker, Row, Col } from "antd";
import dayjs from "dayjs";

const CompanyOdsRecord = ({ records = [] }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (records.length > 0) {
      const latest = records[records.length - 1];
      form.setFieldsValue({
        ...latest,
        date: latest.date ? dayjs(latest.date) : null,
      });
    }
  }, [records, form]);

  return (
    <div className="white-container">
      <h3 className="section-title">ODS Record Details</h3>

      <Form layout="vertical" form={form} disabled>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Date" name="date">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Refrigerant Added (kgs)"
              name="refrigerant_added_kgs"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Initial System Charge"
              name="initial_system_charge"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Refrigerant Recovered"
              name="refrigerant_recovered"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Leak Test Results"
              name="leak_test_results"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Auto Leak Detection Test"
              name="auto_leak_detection_test"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Remarks / Follow-up" name="remarks_followup">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Signed by Electrical Engineer"
              name="sign_engineer"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Signed by Chief Engineer"
              name="sign_chief_engineer"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CompanyOdsRecord;
